import { InboxOutlined } from '@ant-design/icons';
import { Button, message, Upload } from 'antd';
import { uploadPresentmentUrl } from 'api/nach';
import axios from 'axios';
import Loading from 'features/nach/components/Loading';
import { useCallback, useState } from 'react';
import { CSVLink } from 'react-csv';
import { useNavigate } from 'react-router-dom';

const { Dragger } = Upload;

const headers = [
  { label: 'Corporate User No', key: 'presentmentId' },
  { label: 'Corporate Name', key: 'umrnNO' },
  { label: 'UMRN NO', key: 'transactionIDREF' },
  { label: 'DEBTORNAME', key: 'dateOfTxn' },
  { label: 'Customer MICR', key: '' },
  { label: 'Customer Debit AC', key: '' },
  { label: 'Transaction ID/REF', key: '' },
  { label: 'Amount', key: '' },
  { label: 'Date of Txn', key: '' },
  { label: 'Batch No', key: '' },
  { label: 'File No', key: '' },
  { label: 'Unique Reference', key: '' },
  { label: 'IFSC', key: '' },
  { label: 'Partner Bank', key: '' },
  { label: 'Sourcing Type', key: '' },
];

export const BulkUploadFile = () => {
  const navigation = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const handleUpload = useCallback(async (selectedFile?: any) => {
    debugger;
    if (!selectedFile) {
      message.error('Please select file.');
      return;
    }
    if (selectedFile.type != 'text/csv') {
      message.error('Please select csv file.');
      return;
    }
    console.log(selectedFile);
    const formdata = new FormData();

    const sourceId = sessionStorage.getItem('sourceId') || '';
    const createBy = sessionStorage.getItem('userId') || '';

    formdata.append('presentmentFile', selectedFile);
    formdata.append('sourceId', sourceId);
    formdata.append('createBy', createBy);
    setIsLoading(true);

    try {
      const response = await axios.post(uploadPresentmentUrl, formdata);
      const res = await response;
      console.log('presentment uploaded response', res);
      if (res.status === 200) {
        message.success('Success');
        navigation(0);
      }
      setIsLoading(false);
    } catch (error) {
      message.error('Failed to upload data!!.');
      setIsLoading(false);
    }
  }, []);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Loading isLoading={isLoading} />
      <div
        style={{
          margin: '14px',
          maxWidth: '480px',
          maxHeight: '480px',
          padding: '20px',
        }}
      >
        <Dragger
          beforeUpload={handleUpload}
          //  {...props}
          showUploadList={false}
        >
          <p className="ant-upload-drag-icon">
            <InboxOutlined />
          </p>
          <p className="ant-upload-text">Click or drag file to this area to upload</p>
          <p className="ant-upload-hint">
            Support for a single csv upload. Strictly prohibited from uploading other files.
          </p>
        </Dragger>
        <CSVLink
          data={[]}
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: '30px',
          }}
          headers={headers}
          filename="PresentmentUploadTemplate.csv"
        >
          <Button type="primary">Download Template</Button>
        </CSVLink>
      </div>
    </div>
  );
};
